// @mui
import { Card } from '@mui/material';
// dto
import { ReportRowDto } from 'src/api';
// types
import { ReportTemplateContainer } from 'src/types/report-template';
// components
import { ReportTable } from 'src/components/report/report-table';
// columns
import { ColumnTemplates } from 'src/components/report/column';

type props = {
  table: ReportTemplateContainer;
  rows: ReportRowDto[];
  index: number;
  dataSource?: string[];
};

export default function ReportTableElement({ table, rows, index, dataSource }: props) {
  return (
    <Card>
      <ReportTable rows={rows} columns={ColumnTemplates()} table={table} index={index} />
    </Card>
  );
}
